import React, { useEffect } from 'react';

import { AirportImage } from '_organisms';

// bootstrap
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

// redux
import { selectUserDb, selectTravelAgent } from '_redux/slices/main-screen/user';
import { useSelector, useDispatch } from 'react-redux';
import { selectIata, fetchAirportInfo, selectAirportInfo, selectAirportStatus } from '_redux/slices/main-screen/user';

// styles and images
import { Spacing } from '_styles';

import { Title as TremorTitle, Subtitle } from '@tremor/react';

const Title = (props) => {

    // redux
    const dispatch = useDispatch();
    const userDb = useSelector(selectUserDb);
    const travelAgent = useSelector(selectTravelAgent);
    const iata = useSelector(selectIata);
    const airportInfo = useSelector(selectAirportInfo)
    const status = useSelector(selectAirportStatus)

    useEffect(() => {
        if (!travelAgent && userDb.role !== "RETAILER" && userDb && userDb.details && userDb.details.authority !== "ALL" && airportInfo == null) {
            const payload = {
                airline: userDb.details.type === "AIRLINE",
                code: userDb.details.authority
            }
            dispatch(fetchAirportInfo(payload))
        }
    }, [iata]);




    return (
        <>

            {/* Page Title and Description */}
            <Row className='mt-3 mt-md-5 mb-3 mb-md-0'>
                <Col style={{ minWidth: 0 }}>
                    <TremorTitle>{props.subtitle}</TremorTitle><Subtitle>{props.description}</Subtitle>
                </Col>
                {/* airport name / logo: hidden on phones (below md) to give the page title the full width */}
                <Col md={3} lg={2} className='d-none d-md-block' style={{ textAlign: 'right', marginBottom: Spacing.SCALE_22 }}>
                    {userDb.details.authority == 'Healthcare Abroad' ?
                        <AirportImage iata={userDb.details.authority} height={140} />
                        : ''
                    }
                    {
                        status == 'loading' ? '' :
                            <>
                                <TremorTitle>
                                    {(userDb.details.type == 'AIRLINE' && userDb.details.authority === "ALL") || userDb.details.type == 'TRAVEL_AGENT' ? '' : airportInfo && airportInfo.name ? airportInfo.name : "Not provided"}
                                </TremorTitle>
                                <div>
                                    <Subtitle>
                                        {travelAgent || (userDb.details.type == 'AIRLINE' && userDb.details.authority === "ALL") ? '' : airportInfo && airportInfo.locationServed ? airportInfo.locationServed : ""}
                                    </Subtitle>
                                </div>
                            </>
                    }
                </Col>
            </Row>
        </>
    );
};

export default Title;
